import { pageViewEventHandler, loginEventHandler, errorViewHandler, pageNotFoundEventHandler } from "../shared/base";
import { donationWidgetLoadedEventHandler, donationAddToCartEventHandler } from "../shared/DonationWidget";
import { searchInitiatedEventHandler, searchResultsViewEventHandler, searchResultsClickEventHandler, searchFilterClickEventHandler, searchResultsErrorEventHandler } from "./SiteSearch";
import { sponAppChildInteractions, sponAppChildGridView, sponAppCardClick, sponAppPageView, sponAppChildDetailView, sponAppShareCopy, sponAppAddToCart } from "./SponApp";
import { alertBarNotificationView, alertBarClick } from "./AlertBar";
import { ghfEventsHandler } from "../shared/ghf";
import { gravityFormInView, gravityFormOnError, gravityFormOnStart, gravityFormOnSubmit, gravityFormsNewsletter } from "../shared/gravityForms";
import { bibLookupFail, bibLookupSuccess } from "./Global6K";
import { videoAssetInteraction } from "../shared/videoGallery";
import { streamlinedAddBillingAddress, streamlinedAddPaymentInfo, streamlinedAddToCart, streamlinedRemoveToCart, streamlinedAltPayView, streamlinedBeginCheckout, streamlinedCheckoutViewItem, streamlinedBeginCheckoutAltPay, streamlinedPhotoModeration, streamlinedPhotoRetake, streamlinedPhotoUpload, streamlinedThankYouView, streamlinedPurchase, streamlinedCheckoutError } from "../shared/streamlinedCheckout";
import { photoModError, photoUploadClick } from "../shared/photoModeration";
(function (global) {
    // Pageview Event
    global.document.addEventListener("page_view", pageViewEventHandler);
    global.document.addEventListener("error_page_not_found", pageNotFoundEventHandler);
    // Login Event
    global.document.addEventListener("login_success", loginEventHandler);
    // Site Search
    global.document.addEventListener("search_initiated", searchInitiatedEventHandler);
    global.document.addEventListener("search_results_view", searchResultsViewEventHandler);
    global.document.addEventListener("search_results_click", searchResultsClickEventHandler);
    global.document.addEventListener("search_filter_click", searchFilterClickEventHandler);
    global.document.addEventListener("search_results_error", searchResultsErrorEventHandler);
    // Donation Widget 
    global.document.addEventListener("donation_widget_loaded", donationWidgetLoadedEventHandler);
    global.document.addEventListener("donation_add_to_cart", donationAddToCartEventHandler);
    // Sponsorship App
    global.document.addEventListener("spon_app_child_interaction", sponAppChildInteractions);
    global.document.addEventListener("spon_app_child_grid_view", sponAppChildGridView);
    global.document.addEventListener("spon_app_card_click", sponAppCardClick);
    global.document.addEventListener("spon_app_page_view", sponAppPageView);
    global.document.addEventListener("spon_app_child_detail_view", sponAppChildDetailView);
    global.document.addEventListener("spon_app_share_copy", sponAppShareCopy);
    global.document.addEventListener("spon_app_add_to_cart", sponAppAddToCart);
    // Gravity Forms
    global.document.addEventListener("gf_view_event", gravityFormInView);
    global.document.addEventListener("gf_start_event", gravityFormOnStart);
    global.document.addEventListener("gf_submit_success_event", gravityFormOnSubmit);
    global.document.addEventListener("gf_error_event", gravityFormOnError);
    global.document.addEventListener("gf_newsletter_event", gravityFormsNewsletter);
    // Global 6k
    global.document.addEventListener("bib_lookup_fail", bibLookupFail);
    global.document.addEventListener("bib_lookup_success", bibLookupSuccess);
    // Video Asset Interactions
    global.document.addEventListener("video_asset_interaction", videoAssetInteraction);
    // Global header and footer
    var ghfEvents = [
        "ghf_navigation",
        "cart_set"
    ];
    ghfEvents.forEach(function (eventKey) {
        global.document.addEventListener(eventKey, ghfEventsHandler);
    });
    // Alert Bar
    global.document.addEventListener("alert_bar_click", alertBarClick);
    global.document.addEventListener("alert_bar_notification_view", alertBarNotificationView);
    // Shared Events
    global.document.addEventListener("error_view", errorViewHandler);
    /********************************************
     * Streamlined Checkout Events
     * ******************************************/
    global.document.addEventListener("streamlined_checkout_add_to_cart", streamlinedAddToCart);
    global.document.addEventListener("streamlined_checkout_remove_from_cart", streamlinedRemoveToCart);
    global.document.addEventListener("streamlined_checkout_add_billing_address", streamlinedAddBillingAddress);
    global.document.addEventListener("streamlined_checkout_add_payment_info", streamlinedAddPaymentInfo);
    global.document.addEventListener("streamlined_checkout_begin_checkout", streamlinedBeginCheckout);
    global.document.addEventListener("streamlined_checkout_alt_pay_view", streamlinedAltPayView);
    global.document.addEventListener("streamlined_checkout_view_item", streamlinedCheckoutViewItem);
    global.document.addEventListener("streamlined_checkout_begin_checkout_alt_pay", streamlinedBeginCheckoutAltPay);
    global.document.addEventListener("streamlined_checkout_photo_moderation", streamlinedPhotoModeration);
    global.document.addEventListener("streamlined_checkout_photo_retake", streamlinedPhotoRetake);
    global.document.addEventListener("streamlined_checkout_photo_upload", streamlinedPhotoUpload);
    global.document.addEventListener("streamlined_checkout_thank_you_view", streamlinedThankYouView);
    global.document.addEventListener("streamlined_checkout_purchase", streamlinedPurchase);
    global.document.addEventListener("streamlined_checkout_error", streamlinedCheckoutError);
    /***********************
     * Photo Moderation Events
    *************************/
    global.document.addEventListener("photo_upload_click", photoUploadClick);
    global.document.addEventListener("photo_moderation_error", photoModError);
})(window);
